// src/views/Users/Customers/Customers.jsx
import { useState, useEffect, useRef } from "react";
import { globalConstants, modeConstants } from "../constants";
import { useDispatch, useSelector } from "react-redux";
import ActionsDataTable from "../shared/ActionsDataTable";
import { blogActions, userActions } from "../redux/actions";
import UserModal from "../shared/BlogModal";
import { getUserData, SCREENS_IDS } from "../system";
import BlogModal from "../shared/BlogModal";

export default function Blogs() {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const dispatch = useDispatch();
  const sortingInProgressRef = useRef(false);
  const decryptedData = getUserData();

  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  // modal + row state
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [showUserModal, setShowUserModal] = useState(false);
  const [rowData, setRowData] = useState([]);
  const allData = useSelector((s) => s.blogReducer.data);

  // filters aligned to table fields
  const filterColumns = [];

  const columns = [
    {
      id: "date",
      name: "Date",
      selector: (r) => r.date,
      sortable: true,
      grow: 1.6,
    },
    {
      id: "blog_url",
      name: "Blog Url",
      cell: (r) => <div className="email-wrap">{r.blog_url}</div>,
      sortable: true,
      grow: 1.6,
    },
    {
      id: "tag",
      name: "Tag",
      selector: (r) => r.tag,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span>{row.tag}</span>
        </div>
      ),
    },
    {
      id: "is_show_on_home_page",
      name: "Is Show On Home Page",
      selector: (r) => r.is_show_on_home_page ? "Yes" : "No",
      sortable: true,
      grow: 1.6,
    },
    // Toggle
    {
      id: "is_active",
      name: "IsActive",
      sortable: false,
      width: "110px",
      selector: (r) => r.is_active,
      cell: (row) => (
        <div
          className="form-check form-switch m-0"
          onClick={(e) => e.stopPropagation()}
          title={row.is_active == 1 ? "Active" : "Inactive"}
        >
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={row.is_active == 1 ? true : false}
            onChange={() => {
              toggleStatus(row.id);
            }}
            aria-checked={row.is_active == 1 ? true : false}
          />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    // Actions
    {
      name: "Actions",
      sortable: false,
      width: "170px",
      cell: (row) => (
        <div
          className="d-flex align-items-center gap-2"
          onClick={(e) => e.stopPropagation()}
        >
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              title="Edit"
              aria-label="Edit"
              onClick={() => {
                getRowData(row, modeConstants.UPDATE_MODE);
                setShowUserModal(true);
              }}
            >
              <i className="bi bi-pencil" />
            </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const getRowData = (row, nextMode) => {
    dispatch(blogActions.getBlogById(row.id));
    setMode(nextMode);
  };

  const toggleStatus = (id) => {
    dispatch(blogActions.deleteBlogById(id));
  };

  const deleteRow = (row) => {
    dispatch(userActions.deleteUserPermanentById(row.id));
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn.id} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    dispatch(blogActions.getAllBlog());
  };
  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  // useEffect(() => {
  //   // getAll();
  //   sortingInProgressRef.current = false;
  //   // eslint-disable-next-line
  // }, [gridState]);

  useEffect(() => {
    getAll();
  }, []);

  return (
    <>
      <BlogModal
        show={showUserModal}
        onHide={() => setShowUserModal(false)}
        mode={mode}
      />

      <ActionsDataTable
        columns={columns}
        filterColumns={filterColumns}
        data={rowData}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        paginationServer={false}
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData?.length}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setShowModal={setShowUserModal}
        setMode={setMode}
        setGridState={setGridState}
        allowToolbar = {true}
        allowFilters = {false}
      />
    </>
  );
}
